<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Directory</h1>
      <ul>
        <li><a class="active" routerLink="/">Home</a></li>
        <li><a>Alumni</a></li>
        <li>Directory</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 section-layout">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <alumni-menu></alumni-menu>
        </div>

        <div class="col-lg-8">
          <div class="blog-item">
            <div class="blog-content">
              <h3 class="blog-title">Student Directory</h3>
              <div class="blog-desc management-desc">
                Our comprehensive student directory helps you connect with classmates, find contact information, and build your professional network. Browse through our complete listing of current and alumni students to reconnect with peers and expand your scholarly connections.
              </div>
              <div class="blog-desc management-desc">
                The student directory is an invaluable resource for networking and maintaining relationships within our academic community. Whether you're looking to reconnect with old classmates or build professional relationships with fellow alumni, this directory provides easy access to contact information and enables meaningful connections.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
